import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

import ChangeTextWithColorAndImage from '@/app/shared-components/ColorAndImageText/ColorAndImageText';
import {IMAGES} from '@/constants/images';
import {COLORS} from '@/styles/colors';

import CardThemesCarousel from '../../components/CardThemesCarousel/CardThemesCarousel';
import ConfirmCardThemeModal from '../../components/ConfirmCardThemeModal/ConfirmCardThemeModal';

import {
  ChooseCardThemeCategoryViewModelProvider,
  useChooseCardThemeCategoryProvider,
} from './ViewModelContext';

import './styles';

const ChooseCardThemeCategoryContent = () => {
  const {t} = useTranslation();
  const {
    isConfirmCardThemeModalOpen,
    cardThemeSelected,
    onConfirmCardThemeModal,
    onCardThemeSelected,
    onCloseCardThemeModal,
  } = useChooseCardThemeCategoryProvider();

  return (
    <Box className="container-choose-card">
      <img
        src={IMAGES.LOGO_TEXT_BLACK.src}
        height="auto"
        className="modak-logo"
        alt="Modak Logo"
      />
      <Box className="header">
        <ChangeTextWithColorAndImage
          text={`${t('select_category_card_theme.title1')} <${COLORS.ELECTRIC_VIOLET};${t('select_category_card_theme.title2')}> ${t('select_category_card_theme.title3')}`}
          textStyle={{
            color: COLORS.ON_SURFACE,
            fontSize: 22,
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: -0.22,
          }}
        />
      </Box>

      {/* Category Cards Section */}
      <CardThemesCarousel onCardThemeSelected={onCardThemeSelected} />

      <ConfirmCardThemeModal
        cardThemeSelected={cardThemeSelected}
        open={isConfirmCardThemeModalOpen}
        onClose={onCloseCardThemeModal}
        onContinue={onConfirmCardThemeModal}
      />
    </Box>
  );
};

const ChooseCardThemeCategoryPage = () => (
  <ChooseCardThemeCategoryViewModelProvider>
    <ChooseCardThemeCategoryContent />
  </ChooseCardThemeCategoryViewModelProvider>
);

export default ChooseCardThemeCategoryPage;
